import React from 'react';

export function LegalDisclaimer({ className = '' }) {
  return (
    <div className={`text-xs text-gray-600 leading-relaxed ${className}`.trim()}>
      <div className="max-w-5xl mx-auto">
        <div className="border-t border-gray-200 pt-3">
          <p className="break-words">
            Este acervo opera como <span className="font-bold text-gray-600">Curadoria / Biblioteca Digital Especializada</span>, com finalidade de
            utilidade pública e difusão do conhecimento jurídico e científico.
          </p>
          <p className="mt-2 break-words">
            Nos termos do <span className="font-bold text-gray-600">art. 8º, IV, da Lei 9.610/98</span>, atos oficiais (leis, decretos, regulamentos e
            decisões judiciais) não são protegidos por direito autoral, podendo ser livremente reproduzidos e preservados.
          </p>
          <p className="mt-2 break-words">
            A autoria original (relator/pesquisador/instituição) e a fonte de publicação são sempre indicadas. O Portal não reivindica autoria sobre os
            textos originais e mantém links próprios para mitigar perda de acesso ("link rot").
          </p>
        </div>
      </div>
    </div>
  );
}